import { render, staticRenderFns } from "./AutoPortfolioView.vue?vue&type=template&id=1dbf06ff&scoped=true&"
import script from "./AutoPortfolioView.vue?vue&type=script&lang=js&"
export * from "./AutoPortfolioView.vue?vue&type=script&lang=js&"
import style0 from "./AutoPortfolioView.vue?vue&type=style&index=0&id=1dbf06ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf06ff",
  null
  
)

export default component.exports